<div class="form-field">
  @if (props['label']) {
  <label [for]="id" class="form-label">
    {{ props['label'] }}
    @if (props['required']) {
    <span class="required-indicator"> (required)</span>
    }
  </label>
  }
  <input [id]="id" class="form-input" [type]="props['type'] || 'text'" [formControl]="formControl"
    [formlyAttributes]="field" [placeholder]="(props['placeholder'] || '') | translate"
    [required]="props['required'] || false"
    [attr.data-testid]="props['attributes']?.['data-testid'] || ('field-' + field.key)" />
  @if (props['description']) {
  <div class="form-description">{{ props['description'] }}</div>
  }
  @if (formControl.touched && formControl.errors) {
  <div class="field-error">
    @if (formControl.errors['required']) {
    <span>{{ 'field.validation.required' | translate }}</span>
    }
  </div>
  }
</div>